import React from 'react';

export type useBooleanType = (
    initialValue: boolean
) => [state: boolean, toggleState: (condition?: boolean | any) => void];

export const useBoolean: useBooleanType = initialValue => {
    const [state, setState] = React.useState<boolean>(initialValue);

    const toggleState = React.useCallback(
        (condition?: boolean | any) =>
            setState(prevState =>
                typeof condition === 'boolean' ? condition : !prevState
            ),
        []
    );

    return [state, toggleState];
};
